import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { assertDefined, getCore } from '@dynamic-labs-sdk/client/core';
import SignClient from '@walletconnect/sign-client';

export const createSignClient = async (client: DynamicClient) => {
  const core = getCore(client);

  assertDefined(client.projectSettings, 'Project settings not available');

  const generalSettings = client.projectSettings.general;

  assertDefined(
    generalSettings.displayName,
    'Please configure an app name in dashboard to use WalletConnect'
  );

  const projectId = client.projectSettings.sdk.walletConnect?.projectId;

  assertDefined(
    projectId,
    'Please configure a project ID for WalletConnect in dashboard'
  );

  const customStoragePrefix = `dynamic_${core.environmentId}_walletconnect`;

  const displayName = core.metadata?.name ?? generalSettings.displayName;

  const appLogo = core.metadata?.iconUrl ?? generalSettings.appLogo;

  return SignClient.init({
    customStoragePrefix,
    metadata: {
      description: '',
      icons: appLogo ? [appLogo] : [],
      name: displayName,
      redirect: {
        native: core.metadata?.nativeLink,
        universal: core.metadata?.universalLink,
      },
      url: core.metadata?.universalLink ?? '',
    },
    projectId,
  });
};
